import MultiSelect from "multiselect-react-dropdown";
import React, { useState, useEffect, useCallback, useRef, forwardRef, useImperativeHandle } from "react";
import { set, useForm, Controller } from "react-hook-form";
import * as PartnerService from "../../Services/Partner/PartnerService";
import * as PartnerUserService from "../../Services/Partner/PartnerUserService";
import toast from "react-hot-toast";
import {
    FaToggleOn,
    FaToggleOff,
    FaPen,
    FaTimes,
    FaSave,
    FaPlus,
    FaSearch,
} from "react-icons/fa";
import Select from "react-select";

const ExtendUserComponent = forwardRef((props, ref) => {
    const { selectedPartner_Code, selectedPartnerUser, setExtendUserList } = props

    // const [extendUserList, setExtendUserList] = useState(false);
    // const [extendUserSearch, setExtendUserSearch] = useState("");
    // const [extendUserResults, setExtendUserResults] = useState([]);
    const [selectedRoles, setSelectedRoles] = useState([]);
    // const [roleDropdownOpen, setRoleDropdownOpen] = useState(false);
    const [activePartnerList, setActivePartnerList] = useState([]);
    const [partnerSearch, setPartnerSearch] = useState("");
    // const [partnerSearchResults, setPartnerSearchResults] = useState([]);
    const [parentPartnerCode, setParentPartnerCode] = useState("");
    const [activeRolesForExtension, setActiveRolesForExtension] = useState([]);
    const [childPartnerCode, setChildPartnerCode] = useState(null);
    const [partnerUserId, setPartnerUserId] = useState(null);
    const [partnerExtensionList, setPartnerExtensionList] = useState([]);
    const [selectedPartners, setSelectedPartners] = useState([]);
    const [filteredOptions, setFilteredOptions] = useState([]);
    const [searchText, setSearchText] = useState("");
    const [changedRoleId, setChangedRoleId] = useState("");

    const [editIndex, setEditIndex] = useState(null);
    const [ActiveRoleList, setActiveRoleList] = useState([]);
    const [InLineRoleList, setInLineRoleList] = useState([]);

    // Column filter states
    const [showColumnFilter, setShowColumnFilter] = useState({
        partnerCode: false,
        partnerName: false
    });
    const [columnFilters, setColumnFilters] = useState({
        partnerCode: '',
        partnerName: ''
    });

    // Filtered data based on column filters
    const filteredPartnerExtensionList = partnerExtensionList.filter((row) => {
        const codeMatch = row.Child_Partner_Code?.toLowerCase().includes(columnFilters.partnerCode.toLowerCase());
        const nameMatch = row.Child_Partner_Name?.toLowerCase().includes(columnFilters.partnerName.toLowerCase());
        return codeMatch && nameMatch;
    });

    const multiSelectExtensionRef = useRef();

    const {
        register: registerExtension,
        handleSubmit: handleExtensionSubmit,
        formState: { errors: errorsExtension },
        control: controlExtension,
        setValue
    } = useForm();

    const handleGetPartnerUserDependedFeildDataListForExtension = (
        partnerCode
    ) => {
        PartnerUserService.GetPartnerUserDependedFeildDataList(partnerCode)
            .then(({ data }) => {
                //debugger;
                if (data.IsSuccess) {
                    setActiveRolesForExtension(data.Data.RoleList);
                } else {
                    setActiveRolesForExtension([]);
                }
            })
            .catch(() => toast.error("Something went wrong."))
            .finally(
                () => { }
                //setLoading(false)
            );
    };

    const handleSavePartnerExtension = (payload) => {
        if (!partnerUserId) {
            toast.error("User ID is required");
            return;
        }
        if (!selectedRoles || selectedRoles.length === 0) {
            toast.error("Please select at least one role");
            return;
        }
        if (!selectedPartners) {
            toast.error("Please select a partner");
            return;
        }

        PartnerService.SavePartnerExtension(payload)
            .then(({ data }) => {
                if (data.IsSuccess) {
                    //debugger;
                    setValue("Partner_Code", null);
                    handleExtendUserClick({ UserId: partnerUserId })
                    toast.success("Partner extended successfully");
                    setSelectedRoles([]);
                    setChildPartnerCode(null);
                    setPartnerSearch("");
                    // setExtendUserList(false);
                    setSelectedPartners([]);
                    setSearchText("");
                    setFilteredOptions([]);
                } else {
                    toast.error(data.ResponseMessage);
                }
            })
            .catch(() => toast.error("Something went wrong."))
            .finally(() =>{
                setSelectedPartners([]);
            });
    };

    const handleUpdateExtension = (det) => {
        const payload = {
            Id: det.Id,
            RoleId: changedRoleId
        }

        PartnerService.UpdatePartnerExtension(payload)
            .then(({ data }) => {
                if (data.IsSuccess) {
                    handleExtendUserClick(det)
                    toast.success("Partner Extension Updated successfully");
                } else {
                    toast.error(data.ResponseMessage);
                }
            })
            .catch(() => toast.error("Something went wrong."));
    }

    const handleActivateDeactivateExtension = (det, activeStatus) => {
        //debugger;
        const payload = {
            Id: det.Id,
            IsActive: activeStatus
        }

        PartnerService.ActivateDeactivatePartnerExtension(payload)
            .then(({ data }) => {
                if (data.IsSuccess) {
                    handleExtendUserClick(det)
                    toast.success("Partner Extension Updated successfully");
                } else {
                    toast.error(data.ResponseMessage);
                }
            })
            .catch(() => toast.error("Something went wrong."));
    }

    const handleExtendUserClick = (rec) => {
        if (!rec.UserId) {
            toast.error("User ID is required");
            return;
        }

        setExtendUserList(true);
        setPartnerUserId(rec.UserId);

        const parentPartnerCode = selectedPartner_Code //selectedPartnerDet?.Partner_Code;

        if (parentPartnerCode && rec.UserId) {
            PartnerService.GetAllPartnerExtensionList(parentPartnerCode, rec.UserId)
                .then(({ data }) => {
                    if (data.IsSuccess) {
                        setPartnerExtensionList(data.Data);
                    } else {
                        setPartnerExtensionList([]);
                    }
                })
                .catch(() => toast.error("Something went wrong"));
        }

        handleGetActivePartnerList(rec.UserId);
    };

    const handleGetActivePartnerList = (Parent_UserId) => {
        PartnerService.GetActivePartnerList(Parent_UserId)
            .then(({ data }) => {
                if (data.IsSuccess) {
                    setActivePartnerList(data.Data);
                    // setParentPartnerCode(selectedPartnerDet?.Partner_Code);
                    setParentPartnerCode(selectedPartner_Code);
                } else {
                    setActivePartnerList([]);
                }
            })
            .catch(() => toast.error("Something went wrong."))
            .finally(() => {
                //setLoading(false)
            });
    };

    const onExtensionSubmit = (data) => {

        const payload = {
            Roleid: Number(data.Role_Id),
            ParentPartnerCode: parentPartnerCode,
            ChildPartnerCode: selectedPartners,
            Parent_UserId: Number(partnerUserId),
        };

        handleSavePartnerExtension(payload)
    }

    const handlePartnerSelect = (partnerCode) => {
        setSelectedPartners((prev) => {
            // Avoid duplicates
            if (!prev.includes(partnerCode)) {
                return [...prev, partnerCode];
            }
            return prev;
        });
        // setSelectedPartners(partnerCode);
        GetPartnerUserDependedFeildDataList(partnerCode);
    };

    // const handlePartnerRemove = (partnerCode) => {
    //     setSelectedPartners((prev) => prev.filter((code) => code !== partnerCode));
    // };

    const GetPartnerUserDependedFeildDataList = (partner_code) => {
        PartnerUserService.GetPartnerUserDependedFeildDataList(partner_code)
            .then(({ data }) => {
                //debugger;
                if (data.IsSuccess) {
                    setActiveRoleList(data.Data.RoleList);
                } else {
                }
            })
            .catch(() => toast.error("Something went wrong."))
            .finally(
                () => { }
                //setLoading(false)
            );
    };

    const GetRoleList_ForExtensionList = (partner_code) => {
        //debugger;
        PartnerUserService.GetPartnerUserDependedFeildDataList(partner_code)
            .then(({ data }) => {
                //debugger;
                if (data.IsSuccess) {
                    setInLineRoleList(data.Data.RoleList);
                } else {
                }
            })
            .catch(() => toast.error("Something went wrong."))
            .finally(
                () => { }
                //setLoading(false)
            );
    };

    useEffect(() => {
        // GetPartnerUserDependedFeildDataList(selectedPartnerDet.Partner_Code);
        GetPartnerUserDependedFeildDataList(selectedPartner_Code);
        handleGetPartnerUserDependedFeildDataListForExtension();
        handleExtendUserClick(selectedPartnerUser);
    }, []);

    return (
        <>
            {/* Overlay */}
            <div
                className="right-panel-overlay-partner-user-modal"
                onClick={() => setExtendUserList(false)}
            />

            {/* Panel */}
            <div className="right-panel-partner-user-modal">
                <div className="right-panel-header">
                    <div className="right-panel-header-content">
                        <h5 className="mt-1">Extend User</h5>
                        <button
                            type="button"
                            className="btn-close mr-3"
                            onClick={() => setExtendUserList(false)}
                            style={{ transform: "scale(0.6)", fontSize: "20px" }}
                        ></button>
                    </div>
                </div>

                <div className="right-panel-body-extend-user">
                    <form onSubmit={handleExtensionSubmit(onExtensionSubmit)} autoComplete="off">
                        <div className="container mb-0" style={{ fontSize: "13px" }}>
                            <div className="row">
                                {/* Hidden UserId */}
                                <input
                                    type="text"
                                    hidden
                                    className="form-control"
                                    {...registerExtension("UserId")}
                                    defaultValue={selectedPartnerUser?.UserId || null}
                                />

                                {/* Partner Search */}
                                <div className="col-md-12 mb-2 position-relative">
                                    <label className="fw-bold required mb-0-5">Select Partner</label>
                                    {/* <Controller
                                        name="Partner_Code"
                                        control={controlExtension} // 👈 from useForm()
                                        rules={{ required: "Partner is required" }}
                                        render={({ field }) => (
                                            <MultiSelect
                                                ref={multiSelectExtensionRef}
                                                className="multi-select-extend-user"
                                                options={searchText.length >= 2 ? filteredOptions : []} // Only show options if 3+ chars
                                                displayValue="Partner_Code"
                                                placeholder="Type atleast 3 characters"
                                                showSearch={true}
                                                onSearch={(text) => {
                                                    setSearchText(text);
                                                    if (text.length >= 2) {
                                                        const results = activePartnerList.filter((partner) =>
                                                            partner.Partner_Code.toLowerCase().includes(text.toLowerCase())
                                                        );
                                                        setFilteredOptions(results);
                                                    } else {
                                                        setFilteredOptions([]);
                                                    }
                                                }}
                                                onSelect={(selectedList, selectedItem) => {
                                                    field.onChange(selectedList.map(item => item.Partner_Code)); // 👈 update RHF
                                                    handlePartnerSelect(selectedItem.Partner_Code);
                                                }}
                                                onRemove={(selectedList, removedItem) => {
                                                    field.onChange(selectedList.map(item => item.Partner_Code)); // 👈 update RHF
                                                    handlePartnerRemove(removedItem.Partner_Code);
                                                }}
                                                value={field.value}
                                            />
                                        )}
                                    /> */}

                                    <Controller
                                        name="Partner_Code"
                                        control={controlExtension}
                                        rules={{ required: "Partner is required" }}
                                        render={({ field }) => (
                                            <Select
                                                {...field}
                                                className="basic-single"
                                                classNamePrefix="select"
                                                placeholder="Type at least 3 characters"
                                                isSearchable
                                                menuPortalTarget={document.body}
                                                menuPosition="fixed"
                                                options={
                                                    searchText.length >= 2
                                                        ? filteredOptions.map((partner) => ({
                                                            value: partner.Partner_Code,
                                                            Partner_Name: partner.Partner_Name,
                                                            Partner_Code: partner.Partner_Code,
                                                            Payment_Type: partner.Payment_Type,
                                                        }))
                                                        : []
                                                }
                                                onInputChange={(text) => {
                                                    setSearchText(text);
                                                    if (text.length >= 3) {
                                                        const results = activePartnerList.filter((partner) =>
                                                            partner.Partner_Code.toLowerCase().includes(text.toLowerCase()) ||
                                                            partner.Partner_Name.toLowerCase().includes(text.toLowerCase())
                                                        );
                                                        setFilteredOptions(results);
                                                    } else {
                                                        setFilteredOptions([]);
                                                    }
                                                }}
                                                onChange={(selectedOption) => {
                                                    field.onChange(selectedOption); // 👈 store full object
                                                    if (selectedOption) handlePartnerSelect(selectedOption.Partner_Code);
                                                }}
                                                value={field.value || null} // 👈 now field.value is full partner object
                                                getOptionLabel={(option) =>
                                                    `${option.Partner_Name} (${option.Partner_Code}) ${option.Payment_Type}`
                                                }
                                                getOptionValue={(option) => option.Partner_Code}
                                                formatOptionLabel={(option) => (
                                                    <div
                                                        style={{
                                                            display: "flex",
                                                            justifyContent: "space-between",
                                                            alignItems: "center",
                                                            whiteSpace: "normal",
                                                            wordWrap: "break-word",
                                                            lineHeight: "1.2",
                                                            fontSize: "12px",  
                                                        }}
                                                    >
                                                        <div style={{ flex: "1", paddingRight: "10px" }}>
                                                            <strong>{option.Partner_Name}</strong> ({option.Partner_Code})
                                                        </div>
                                                        <div style={{ color: "#666", whiteSpace: "nowrap" }}>
                                                            {option.Payment_Type}
                                                        </div>
                                                    </div>
                                                )}
                                                styles={{
                                                    option: (base) => ({
                                                        ...base,
                                                        whiteSpace: "normal",
                                                        wordWrap: "break-word",
                                                    }),
                                                    singleValue: (base) => ({
                                                        ...base,
                                                        display: "flex",
                                                        justifyContent: "space-between",
                                                        alignItems: "center",
                                                        whiteSpace: "normal",
                                                        wordWrap: "break-word",
                                                        lineHeight: "1.2",
                                                        width: "100%",
                                                    }),
                                                    menuPortal: (base) => ({
                                                        ...base,
                                                        zIndex: 9999,
                                                    }),
                                                }}
                                            />
                                        )}
                                    />


                                    {errorsExtension.Partner_Code && (
                                        <p className="text-danger required_error">
                                            {errorsExtension.Partner_Code.message}
                                        </p>
                                    )}
                                </div>

                                {/* Role List Dropdown */}
                                <div className="col-md-12 mb-2">
                                    <label className="fw-bold required mb-0-5">Select Role</label>
                                    <select
                                        className="form-select"
                                        value={selectedRoles}
                                        {...registerExtension("Role_Id", { required: "Role is required" })}
                                        onChange={(e) => setSelectedRoles(Number(e.target.value))}
                                       disabled={selectedPartners.length === 0}
                                    >
                                        <option value="">Select Role</option>
                                        {ActiveRoleList.map((role) => (
                                            <option key={role.Role_Id} value={role.Role_Id}>
                                                {role.Role_Name}
                                            </option>
                                        ))}
                                    </select>
                                    {errorsExtension.Role_Id && (
                                        <p className="text-danger required_error">
                                            {errorsExtension.Role_Id.message}
                                        </p>
                                    )}
                                </div>
                            </div>

                            {/* Buttons */}
                            <div className="d-flex justify-content-end mb-3 gap-2">
                                {/* <button type="button" className="btn btn-danger">Cancel</button> */}
                                <button type="submit" className="btn custom-sumbitbtn d-flex align-items-center gap-2">
                                    <FaPlus size={14} />
                                    Add User
                                </button>
                            </div>
                        </div>
                    </form>

                    <div className="table-responsive-extenduser" style={{ maxHeight: "350px", overflowY: "auto" }}>
                        <table className="table table-bordered custom-table m-0">
                            <thead>
                                <tr>
                                    <th style={{ width: "20%" }}>
                                        Partner Code
                                        <FaSearch
                                            style={{ marginLeft: 6, cursor: 'pointer' }}
                                            onClick={() => setShowColumnFilter(f => ({ ...f, partnerCode: !f.partnerCode }))}
                                        />
                                    </th>
                                    <th style={{ width: "25%" }}>
                                        Partner Name
                                        <FaSearch
                                            style={{ marginLeft: 6, cursor: 'pointer' }}
                                            onClick={() => setShowColumnFilter(f => ({ ...f, partnerName: !f.partnerName }))}
                                        />
                                    </th>
                                    <th style={{ width: "20%" }}>
                                        Role
                                    </th>
                                    <th style={{ width: "12%" }}>
                                        Active
                                    </th>
                                    <th style={{ width: "9%" }}>Action</th>
                                </tr>
                                {/* Filter row */}
                                {(showColumnFilter.partnerCode || showColumnFilter.partnerName) && (
                                    <tr>
                                        <td style={{ padding: 4, background: '#f8f9fa' }}>
                                            {showColumnFilter.partnerCode ? (
                                                <input
                                                    type="text"
                                                    className="form-control form-control-sm"
                                                    placeholder="Search Code"
                                                    value={columnFilters.partnerCode}
                                                    onChange={e => setColumnFilters(f => ({ ...f, partnerCode: e.target.value }))}
                                                    style={{ minWidth: 0 }}
                                                    autoFocus
                                                />
                                            ) : null}
                                        </td>
                                        <td style={{ padding: 4, background: '#f8f9fa' }}>
                                            {showColumnFilter.partnerName ? (
                                                <input
                                                    type="text"
                                                    className="form-control form-control-sm"
                                                    placeholder="Search Name"
                                                    value={columnFilters.partnerName}
                                                    onChange={e => setColumnFilters(f => ({ ...f, partnerName: e.target.value }))}
                                                    style={{ minWidth: 0 }}
                                                    autoFocus={showColumnFilter.partnerName && !showColumnFilter.partnerCode}
                                                />
                                            ) : null}
                                        </td>
                                        <td style={{ background: '#f8f9fa' }}></td>
                                        <td style={{ background: '#f8f9fa' }}></td>
                                        <td style={{ background: '#f8f9fa' }}></td>
                                    </tr>
                                )}
                            </thead>
                            <tbody>
                                {filteredPartnerExtensionList.length > 0 ? (
                                    filteredPartnerExtensionList.map((extension, index) => (
                                        <tr key={index}>
                                            <td style={{ fontSize: "12px" }} >{extension.Child_Partner_Code}</td>
                                            <td style={{ fontSize: "12px" }} title={extension.Child_Partner_Name}>
                                                <div
                                                    style={{
                                                        maxWidth: '150px',
                                                        whiteSpace: 'nowrap',
                                                        overflow: 'hidden',
                                                        textOverflow: 'ellipsis',
                                                        margin: '0 auto'
                                                    }}
                                                >
                                                    {extension.Child_Partner_Name}
                                                </div>
                                            </td>
                                            <td style={{ fontSize: "12px" }}>
                                                {editIndex === index ? (
                                                    <select
                                                        style={{ fontSize: "14px" }}
                                                        className="form-select"
                                                        value={extension?.RoleId || ""}
                                                        onChange={(e) => {
                                                            const roleId = e.target.value;
                                                            setChangedRoleId(roleId);
                                                            extension.RoleId = roleId;
                                                        }}
                                                    >
                                                        <option value="">Select Role</option>
                                                        {InLineRoleList?.map((item) => (
                                                            <option style={{ fontSize: "14px" }}
                                                                key={item.Role_Id.toString()}
                                                                value={item.Role_Id.toString()}
                                                            >
                                                                {item.Role_Name}
                                                            </option>
                                                        ))}
                                                    </select>
                                                ) : (
                                                    extension.Role_Name
                                                )}
                                            </td>

                                            <td>
                                                {extension.IsActive ? (
                                                    <FaToggleOn
                                                        title="Deactivate PartnerUser"
                                                        style={{ cursor: "pointer" }}
                                                        onClick={() =>
                                                            handleActivateDeactivateExtension(extension, !extension.IsActive)
                                                        }
                                                        color="green"
                                                        size={16}
                                                    />
                                                ) : (
                                                    <FaToggleOff
                                                        style={{ cursor: "pointer" }}
                                                        onClick={() =>
                                                            handleActivateDeactivateExtension(extension, !extension.IsActive)
                                                        }
                                                        title="Activate PartnerUser"
                                                        color="red"
                                                        size={16}
                                                    />
                                                )}
                                            </td>
                                            <td>
                                                {editIndex === index ? (
                                                    <>
                                                        <FaTimes
                                                            color="red"
                                                            style={{ cursor: "pointer", marginRight: "6px" }}
                                                            onClick={() => setEditIndex(null)}
                                                        />
                                                        <FaSave
                                                            style={{ cursor: "pointer" }}
                                                            color="green"
                                                            onClick={() => {
                                                                handleUpdateExtension(extension);
                                                                setEditIndex(null);
                                                            }}
                                                        />
                                                    </>
                                                ) : (
                                                    <FaPen
                                                        style={{ cursor: "pointer" }}
                                                        color="green"
                                                        onClick={() => { setEditIndex(index); GetRoleList_ForExtensionList(extension?.Child_Partner_Code); }}
                                                    />
                                                )}
                                            </td>
                                        </tr>
                                    ))
                                ) : (
                                    <tr>
                                        <td colSpan="5" className="text-center">
                                            No extensions found
                                        </td>
                                    </tr>
                                )}
                            </tbody>
                        </table>
                    </div>
                </div>
            </div>
        </>
    )
})

export default ExtendUserComponent